import { Col, Form, Modal, Row } from 'react-bootstrap'
import { CustomButton } from '../../../../components/CustomButton'
import { useState } from 'react'
import { ArrowClockwise, XCircle } from 'phosphor-react'
import { toast } from 'react-toastify'

export function ModalConfirmQuantity({
  isOpen,
  onClose,
  fromAddress,
  toAddress,
  onProcess,
}) {
  const [quantity, setQuantity] = useState('')

  async function handleProcess() {
    const qtd = Number(fromAddress.qt)

    if (qtd === 0) {
      return toast.warn('O produto deve possuir estoque maior que 0!')
    }

    if (fromAddress.codendereco === toAddress.codendereco) {
      return toast.warn(
        'O endereço de destino deve ser diferente do endereço de origem!',
      )
    }

    if (fromAddress.tipoender === 'AP' && toAddress.tipoender === 'AP') {
      return toast.warn(
        'Endereços de picking só podem ser transferidos para endereços aéreos!',
      )
    }

    if (Number(quantity > qtd)) {
      return toast.warn(`Quantidade maior do que a disponível!`)
    }

    const data = {
      fromAddress,
      toAddress,
      quantity,
    }

    onProcess(data)
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      dialogClassName="custom-modalzpl"
    >
      <Modal.Header>
        <Modal.Title>Confirme a quantidade à ser transferida</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="mb-4">
          <p>Endereço Origem</p>

          <Col>
            <Form.Label>Cód. Endereço</Form.Label>
            <Form.Control
              disabled
              value={fromAddress.codendereco}
            />
          </Col>

          <Col>
            <Form.Label>Depósito</Form.Label>
            <Form.Control
              disabled
              value={fromAddress.deposito}
            />
          </Col>

          <Col>
            <Form.Label>Rua</Form.Label>
            <Form.Control
              disabled
              value={fromAddress.rua}
            />
          </Col>

          <Col>
            <Form.Label>Prédio</Form.Label>
            <Form.Control
              disabled
              value={fromAddress.predio}
            />
          </Col>

          <Col>
            <Form.Label>Nível</Form.Label>
            <Form.Control
              disabled
              value={fromAddress.nivel}
            />
          </Col>

          <Col>
            <Form.Label>Apto</Form.Label>
            <Form.Control
              disabled
              value={fromAddress.apto}
            />
          </Col>
        </Row>

        <Row className="mb-4">
          <p>Endereço destino</p>

          <Col>
            <Form.Label>Cód. Endereço</Form.Label>
            <Form.Control
              disabled
              value={toAddress.codendereco}
            />
          </Col>

          <Col>
            <Form.Label>Depósito</Form.Label>
            <Form.Control
              disabled
              value={toAddress.deposito}
            />
          </Col>

          <Col>
            <Form.Label>Rua</Form.Label>
            <Form.Control
              disabled
              value={toAddress.rua}
            />
          </Col>

          <Col>
            <Form.Label>Prédio</Form.Label>
            <Form.Control
              disabled
              value={toAddress.predio}
            />
          </Col>

          <Col>
            <Form.Label>Nível</Form.Label>
            <Form.Control
              disabled
              value={toAddress.nivel}
            />
          </Col>

          <Col>
            <Form.Label>Apto</Form.Label>
            <Form.Control
              disabled
              value={fromAddress.apto}
            />
          </Col>
        </Row>

        <Row xs={6}>
          <Col>
            <Form.Label>Quantidade</Form.Label>
            <Form.Control
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
            />
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <CustomButton
          title="Processar"
          onClick={handleProcess}
          isSuccess
          isDisabled={!quantity}
        >
          <ArrowClockwise
            weight="fill"
            size={20}
          />
        </CustomButton>

        <CustomButton
          title="Cancelar"
          onClick={onClose}
          isDelete
        >
          <XCircle
            weight="fill"
            size={20}
          />
        </CustomButton>
      </Modal.Footer>
    </Modal>
  )
}
